import home_US from './home_US';
import localeDemo_US from './localeDemo_US';

const en_US = Object.assign(
  {},
  home_US,
  localeDemo_US,
);

export default en_US;